"use client";

import { isNil, isString } from "@/common/helpers/lang";
import { cn } from "@/services/styles/cn";

import { Icon } from "../icon";
import { SanitizedContent } from "../sanitized-content";

interface CmsSectionHeadingProps {
  heading: string;
  description?: string;
  title?: string | null;
  classes?: {
    container?: string;
    heading?: string;
    description?: string;
    title?: string;
  };
}

export function CmsSectionHeading({ heading, description, title, classes }: CmsSectionHeadingProps) {
  const isTitle = isString(title) && title.length > 0;

  return (
    <div className={cn("mx-auto", classes?.container)}>
      {isTitle ? (
        <div className={cn("mb-4 flex gap-2 text-dodger-blue-700", classes?.title)}>
          <Icon name="ph:chats" className="text-2xl" />
          <SanitizedContent as="span" content={title} className="font-medium text-base uppercase" />
        </div>
      ) : null}
      <h2 className={cn("mb-8 text-center font-serif text-4xl md:text-5xl", classes?.heading)}>
        <SanitizedContent as="span" content={heading} />
      </h2>
      {isNil(description) ? null : (
        <h3 className={cn("text-xl", classes?.description)}>
          <SanitizedContent as="span" content={description} />
        </h3>
      )}
    </div>
  );
}
